import React from 'react';
import { Navigation } from './Navigation';
import './Dashboard.css';

export const DcaTool: React.FC = () => {
  return (
    <div className="dashboard-container">
      <Navigation />
      <div className="dashboard-content">
        <div className="welcome-section">
          <h2>DCA / Withdrawal Tool</h2>
          <p>Coming soon.</p>
        </div>
      </div>
    </div>
  );
};
